import { Input } from '@trackman/web-shared-components';
import { ReactComponent as SearchIcon } from 'images/icons/Search.svg';
import { observer } from 'mobx-react-lite';

type Props = {
  searchValue: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const HeaderSearchbar = observer(({ searchValue, onChange, placeholder }: Props) => {
  return (
    <div className='admin-list-header-searchbar'>
      <Input
        placeholder={placeholder ? placeholder : 'Search...'}
        value={searchValue ?? ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.currentTarget.value)}
      />
      <SearchIcon />
    </div>
  );
});

export default HeaderSearchbar;
